import React, { ReactNode } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { ROUTES } from "~/const/route";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { AppBar, Toolbar, Button } from "@material-ui/core";
import { logoutAdmin } from "~/redux/modules/admin/auth";
import { RootState } from "~/redux/rootReducer";

type Props = {
  drawerButton?: ReactNode;
};

export const Header: React.VFC<Props> = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  // global state
  const login = useSelector((state: RootState) => state.adminAuth.login);

  // ログアウト
  const onClickLogout = async () => {
    await dispatch(logoutAdmin());
    history.push(ROUTES.ADMIN.LOGOUT);
  };

  return (
    <AppBar className={classes.appBar} position="fixed">
      <Toolbar>
        {props.drawerButton}
        <Link
          className={classes.appBarTitle}
          to={login ? ROUTES.ADMIN.SPECIALIST : ROUTES.ADMIN.LOGIN}
        >
          <h3 className={classes.appBarTitleText}>SHUZO/運営会社向けサイト</h3>
        </Link>
        {login && (
          <Button onClick={onClickLogout} color="inherit">
            ログアウト
          </Button>
        )}
      </Toolbar>
    </AppBar>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
    },
    appBarTitle: {
      flexGrow: 1,
      fontSize: 20,
      color: "#fff",
      textDecoration: "none",
    },
    appBarTitleText: {
      margin: 0,
    },
  })
);
